import { useConfig } from "@/context/ConfigContext";
import Head from "next/head";
import React from "react";

interface PageHeadProps {
  metadata: any;
}

export const PageHead = (props: PageHeadProps) => {
  const { metadata } = props;

  const config = useConfig();

  return (
    <Head>
      {metadata.title && <title>{metadata.title}</title>}
      {metadata.description && (
        <meta name="description" content={metadata.description} />
      )}
      {metadata.title && <meta property="og:title" content={metadata.title} />}
      {metadata.description && (
        <meta property="og:description" content={metadata.description} />
      )}
      <link rel="icon" href="/favicon.ico" sizes="any" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Keperin" />
      {metadata.image && <meta property="og:image" content={metadata.image} />}
      <meta
        property="og:url"
        content={`${config.canonicalDomain}${metadata.path}`}
      />
      <meta property="og:locale" content={metadata.language} />
      <link
        rel="canonical"
        href={`${config.canonicalDomain}${metadata.path}`}
      />
      <meta name="keywords" content={metadata.keywords?.join(",")} />

      <meta name="twitter:card" content="summary_large_image" />
      {metadata.title && <meta name="twitter:title" content={metadata.title} />}
      {metadata.description && (
        <meta name="twitter:description" content={metadata.description} />
      )}
      {metadata.image && <meta name="twitter:image" content={metadata.image} />}
      <meta name="twitter:site" content="@keperin_" />
    </Head>
  );
};
